module.exports = __webpack_public_path__ + "img/total-bag-hanging.aff858dc.svg";